import { createActionGroup, props } from '@ngrx/store';
import { QualityMeasureSurvey, QualityMeasureSurveyAnswer } from '@models/quality-measure-survey.model';

export const QualityMeasureSurveyActions = createActionGroup({
  source: 'Quality Measure Survey',
  events: {
    'Load Survey': props<{ organizationId: number }>(),
    'Load Survey Success': props<{ survey: QualityMeasureSurvey }>(),
    'Load Survey Failure': props<{ error: string }>(),

    'Save Survey': props<{ organizationId: number; answers: QualityMeasureSurveyAnswer[] }>(),
    'Save Survey Success': props<{ organizationId: number }>(),
    'Save Survey Failure': props<{ error: string }>(),

    'Export Survey': props<{ organizationId: number }>(),
    'Export Survey Success': props<{ blob: Blob; filename: string }>(),
    'Export Survey Failure': props<{ error: string }>(),
  },
});
